// @flow

export const ACTIONS = {
    INITIALIZE: 'analytics-initialized',
    INITIALIZE_META: 'analytics-meta-intialize',
    LOAD_MARKETPLACE_PRODUCTS: 'load-marketplace-products',
    LOAD_MARKETPLACE_ATTRIBUTIONS: 'load-marketplace-attributions'
};



// WEBPACK FOOTER //
// ./src/state/reducer/analytics/actions.js